<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <graph-tool-bar :showSource="false" @on-selected="onPanelSelect" :dateRangeMenu="false"></graph-tool-bar>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue"></md-card-header>

        <md-card-content>
          <!--           <md-table v-model="tableData" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="From">
                
              <md-field :class="[{ 'md-error': errors.has('ENERGY') }]">

                <label>Hours</label>
                <md-select v-model="settings.hours" name="ENERGY" v-validate>
                  <md-option value="0">0</md-option>
                  <md-option value="1">1</md-option>
                  <md-option value="2">2</md-option>
                  <md-option value="3">3</md-option>
                  <md-option value="4">4</md-option>
                  <md-option value="5">5</md-option>
                  <md-option value="6">6</md-option>
                </md-select>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('U_L1')">close</md-icon>
                </slide-y-down-transition>

              </md-field>

                            <md-field :class="[{ 'md-error': errors.has('ENERGY') }]">

                <label>Minutes</label>
                <md-select v-model="settings.minutes" name="ENERGY" v-validate>
                  <md-option value="00">00</md-option>
                  <md-option value="15">15</md-option>
                  <md-option value="30">30</md-option>
                  <md-option value="45">45</md-option>
                </md-select> 

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('U_L1')">close</md-icon>
                </slide-y-down-transition>

              </md-field>

              </md-table-cell>



              <md-table-cell md-label="To">sdad</md-table-cell>
            </md-table-row>
          </md-table>-->

          <div class="md-layout">
            <label class="md-layout-item md-size-5 md-form-label">From</label>

            <div class="md-layout-item md-size-15">
              <md-field :class="[{ 'md-error': errors.has('ENERGY') }]">
                <label>Hours</label>
                <md-select v-model="settings.hours" name="ENERGY" v-validate>
                  <md-option v-for="item in availableHours" :key="item.hour" :value="item.hour">{{item.hour}}</md-option>
                </md-select>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('U_L1')">close</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-15">
              <md-field :class="[{ 'md-error': errors.has('ENERGY') }]">
                <label>Minutes</label>
                <md-select v-model="settings.minutes" name="ENERGY" v-validate>
                  <md-option value="00">00</md-option>
                  <md-option value="15">15</md-option>
                  <md-option value="30">30</md-option>
                  <md-option value="45">45</md-option>
                </md-select>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('U_L1')">close</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <label class="md-layout-item md-size-5 md-form-label">To</label>

            <div class="md-layout-item md-size-15">
              <md-field :class="[{ 'md-error': errors.has('ENERGY') }]">
                <label>Minutes</label>
                <md-select v-model="settings.minutes" name="ENERGY" v-validate>
                  <md-option value="00">00</md-option>
                  <md-option value="15">15</md-option>
                  <md-option value="30">30</md-option>
                  <md-option value="45">45</md-option>
                </md-select>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('U_L1')">close</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-15">
              <md-field :class="[{ 'md-error': errors.has('ENERGY') }]">
                <label>Hours</label>
                <md-select v-model="settings.hours" name="ENERGY" v-validate>
                  <md-option value="0">0</md-option>
                  <md-option value="1">1</md-option>
                  <md-option value="2">2</md-option>
                  <md-option value="3">3</md-option>
                  <md-option value="4">4</md-option>
                  <md-option value="5">5</md-option>
                  <md-option value="6">6</md-option>
                </md-select>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('U_L1')">close</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-15 ml-auto">
              <md-field :class="[{ 'md-error': errors.has('ENERGY') }]">
                <label>Tarif</label>
                <md-select v-model="settings.minutes" name="ENERGY" v-validate>
                  <md-option value="VT">VT</md-option>
                  <md-option value="NT">NT</md-option>
                </md-select>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('ENERGY')">close</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
{{availableHours}}
    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>



<script>
import axios from "axios";
import graphToolBar from "@/components/GraphToolBar";
import snackBar from "@/components/SnackBar";
import { SlideYDownTransition } from "vue2-transitions";

import { getSelectedDeviceToken } from "@/storage/memoryStorage";

export default {
  components: {
    graphToolBar,
    snackBar,
    SlideYDownTransition
  },
  data() {
    return {
      settings: {},
      tarifs: [
        {
          from_hours: 5,
          from_minutes: 30,
          to_hours: 6,
          to_minutes: 0
        },
        {
          from_hours: 5,
          from_minutes: 0,
          to_hours: 5,
          to_minutes: 30
        },

        {
          from_hours: 1,
          from_minutes: 0,
          to_hours: 2,
          to_minutes: 0
        }
      ],
      tableData: [
        {
          from_hours: 0,
          from_minutes: 0,
          to_hours: 0,
          to_minutes: 0,
          tarif: ""
        }
      ],

      availableHours: []
    };
  },

  mounted() {
    this.test();
  },

  methods: {
    onPanelSelect(device) {},

    test() {
      const tarifsSort = this.tarifs.sort((a, b) => {
        if (a.from_hours > b.from_hours) {
          return 1;
        } else if (a.from_hours < b.from_hours) {
          return -1;
        } else if (a.from_hours == b.from_hours) {
          if (a.from_minutes > b.from_minutes) {
            return 1;
          } else if (a.from_minutes < b.from_minutes) {
            return -1;
          } else {
            console.log("Sort error");
          }
        }
      });

      console.log("ArraySort", tarifsSort);
      let tarifIndex = 0;

      for (let h = 0; h < 24; h++) {
        let hoursPushIndex = null;
        if (h < Number(tarifsSort[tarifIndex].from_hours) || h > Number(tarifsSort[tarifIndex].to_hours)) {
            this.availableHours.push({
              hour: h,
              minutes: [0,15,30,45]
            });

        } else {
          hoursPushIndex = this.availableHours.push({
              hour: h,
              minutes: []
            }) - 1;
        
        for (let m = 0; m < 60; m += 15) {
          console.log(tarifsSort[tarifIndex]);
          if (m < Number(tarifsSort[tarifIndex].from_minutes)){
          //if (m < tarifsSort[tarifIndex].from_minutes || m > tarifsSort[tarifIndex].to_minutes){
            this.availableHours[hoursPushIndex].minutes.push(m);
          } else {
            //h = Number(tarifsSort[tarifIndex].to_hours);
            //m = Number(tarifsSort[tarifIndex].to_minutes);
            tarifIndex++;
          }
        }

        } 

      }
    }
  }
};
</script>
